import { ol_Feature, ol_Map, ol_source, ol_style, ol_View, ol_geom, ol_layer, ol_VectorLayer } from "@omnia/exports/openlayers";
import { Geolocation } from "ol";
import VectorSource from "ol/source/Vector";

/** @internal */
export class MapGeolocation {

    private view: ol_View

    public geolocation: Geolocation

    private positionFeature: ol_Feature
    private accuracyFeature: ol_Feature
    private layer: ol_VectorLayer

    private firstGeolocationChange: boolean

    public tracking: boolean
    private trace: boolean

    private lastPositionUpdateTime: Date
    private _messages = []


    constructor(private $timeout: ng.ITimeoutService, private map: ol_Map) {

        this.view = map.getView()

        this.setup()

    }

    dispose() {
        // TODO
    }

    private log(type: string, args: any = {}) {

        const error = type == "error"
        const m = (error ? console.error : console.log)

        if (error || this.trace) {
            m(type, args)
        }

        if (this.trace) {

            this._messages.push(({
                type,
                ...args
            }))

            if (this._messages.length > 200) {
                this._messages = this._messages.splice(0, 10)
            }

        }

    }

    private setup() {

        this.geolocation = new Geolocation({
            projection: this.view.getProjection(),
            trackingOptions: {
                enableHighAccuracy: true,
                maximumAge: 0,
                timeout: 30000
            }
        });

        this.geolocation.on('error', error => {
            this.log("error", error)
        })

        this.accuracyFeature = new ol_Feature()
        this.positionFeature = new ol_Feature()
        this.setPositionStyle(this.positionFeature)

        this.layer = new ol_layer.Vector({
            map: this.map,
            declutter: false,
            visible: false,
            source: new ol_source.Vector({
                features: [this.accuracyFeature, this.positionFeature]
            })
        });

        this.geolocation.on('change:accuracyGeometry', () => {

            this.log("change:accuracyGeometry")

            if (this.tracking) {
                this.accuracyFeature.setGeometry(this.geolocation.getAccuracyGeometry());
            } else {
                this.accuracyFeature.setGeometry(null);
            }

        });


        this.geolocation.on('change:position', () => this.updatePosition("change:position"))

        this.geolocation.on('change:tracking', () => this.log("change:tracking", ({ tracking: this.geolocation.getTracking(), options: this.geolocation.getTrackingOptions() })))

        this.geolocation.on('change', () => {
            this.log("change", ({ tracking: this.geolocation.getTracking(), position: this.geolocation.getPosition() }))
            this.updatePosition("change")
        })

    }

    private updatePosition(caller: string) {

        const coordinates = this.geolocation.getPosition()
        this.positionFeature.setGeometry(coordinates ? new ol_geom.Point(coordinates) : null)
        this.lastPositionUpdateTime = new Date(Date.now())

        if (this.firstGeolocationChange) {
            this.view.setCenter(coordinates);
            if (this.view.getZoom() < 15) {
                this.view.setZoom(17);
            }
            this.firstGeolocationChange = false;
        }

    }

    public setTracking(value: boolean, trace: boolean) {

        this.tracking = value;
        this.trace = trace;
        this.firstGeolocationChange = true;

        this.layer.setVisible(value)

        if (!this.tracking) {
            this.stopTracking()
            return
        }

        this.accuracyFeature.setGeometry(this.geolocation.getAccuracyGeometry())
        this.geolocation.setTracking(true)

    }

    private stopTracking() {
        this.accuracyFeature.setGeometry(null)
        this.geolocation.setTracking(false)
    }

    private setPositionStyle(position: ol_Feature) {

        position.setStyle(new ol_style.Style({
            image: new ol_style.Circle({
                radius: 6,
                fill: new ol_style.Fill({
                    color: '#3399CC'
                }),
                stroke: new ol_style.Stroke({
                    color: '#fff',
                    width: 2
                })
            })
        }));
    }

    public getTrackingInfo() {

        return {
            tracking: this.geolocation.getTracking(),
            position: this.geolocation.getPosition(),
            lastUpdate: this.lastPositionUpdateTime,
            messages: this._messages
        }
    }

}
